import type { LmsAdapter, MappingFormData } from './types';

export const xtramileAdapter: LmsAdapter = {
  lmsType: 'xtramile',
  displayName: 'Xtramile',
  shortDescription: 'Koble Xtramile-kurs til en godkjent studieplan',
  colors: {
    bg: 'bg-blue-50',
    border: 'border-blue-200',
    badge: 'bg-blue-100 text-blue-800',
    primary: 'bg-blue-600 hover:bg-blue-700'
  },
  courseIdField: {
    label: 'Xtramile kurs-ID',
    placeholder: 'F.eks. abc-123-def',
    helpText: 'Xtramile-kurs-ID fra deres system',
    inputType: 'text',
    validate: (v) => v.trim().length > 0 ? null : 'Kurs-ID er påkrevd',
    parse: (v) => v.trim()
  },
  courseNameField: {
    label: 'Kursnavn i Xtramile',
    placeholder: 'Eksakt tittel som vist i Xtramile',
    required: true
  },
  endpoints: {
    // Xtramile har ikke per-member listing-endepunkt, bare per-integration
    listMappingsForMember: (mid) => `/api/xtramile/mappings/member/${mid}`,
    listMappingsForIntegration: (iid) => `/api/xtramile/mappings/${iid}`,
    createMappingForMember: () => `/api/xtramile/mappings`,
    updateMapping: (id) => `/api/xtramile/mappings/${id}`,
    deleteMapping: (id) => `/api/xtramile/mappings/${id}`,
    // Xtramile har detect-endpoint, men ikke generell autocomplete
  },
  buildCreateBody: (data: MappingFormData) => ({
    xtramile_course_id: data.lmsCourseId,
    xtramile_course_name: data.lmsCourseName,
    study_plan_id: data.studyPlanId,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null
  }),
  buildUpdateBody: (data: MappingFormData) => ({
    xtramile_course_name: data.lmsCourseName,
    assessment_type: data.assessmentType,
    no_self_assessment_confirmed: data.noSelfAssessmentConfirmed,
    controlled_conditions_confirmed: data.controlledConditionsConfirmed,
    module_codes: data.moduleCodes.length > 0 ? data.moduleCodes : null,
    ects_credits: data.ectsCredits ?? null,
    certificate_title: data.certificateTitle ?? null,
    certificate_description: data.certificateDescription ?? null
  })
};
